import React, { useState } from 'react';
import { SectionWrapper } from '../common';
import { faqItems } from '../../data/faq';

const styles = {
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 500px), 1fr))',
    gap: '16px',
  },
};

const itemStyles = {
  container: {
    backgroundColor: 'rgba(15, 23, 42, 0.6)',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(255, 255, 255, 0.05)',
    borderRadius: '12px',
    overflow: 'hidden',
    transition: 'all 0.3s ease',
  },
  containerOpen: {
    border: '1px solid rgba(59, 130, 246, 0.3)',
  },
  button: {
    width: '100%',
    padding: '20px 24px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    textAlign: 'left',
  },
  question: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#fff',
    fontFamily: "'DM Sans', sans-serif",
    paddingRight: '16px',
  },
  icon: {
    fontSize: '24px',
    color: '#3b82f6',
    transition: 'transform 0.3s ease',
    flexShrink: 0,
  },
  content: {
    overflow: 'hidden',
    transition: 'max-height 0.3s ease, padding 0.3s ease',
  },
  answer: {
    fontSize: '15px',
    color: '#94a3b8',
    lineHeight: '1.7',
  },
};

const FaqItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div style={{
      ...itemStyles.container,
      ...(isOpen ? itemStyles.containerOpen : {}),
    }}>
      <button onClick={() => setIsOpen(!isOpen)} style={itemStyles.button}>
        <span style={itemStyles.question}>{question}</span>
        <span style={{
          ...itemStyles.icon,
          transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)',
        }}>+</span>
      </button>
      <div style={{
        ...itemStyles.content,
        maxHeight: isOpen ? '300px' : '0',
        padding: isOpen ? '0 24px 20px' : '0 24px',
      }}>
        <p style={itemStyles.answer}>{answer}</p>
      </div>
    </div>
  );
};

export const FAQ = ({ isVisible }) => {
  return (
    <SectionWrapper
      id="faq"
      label="FAQ"
      title="Veelgestelde vragen"
      isVisible={isVisible}
      backgroundColor="rgba(15, 23, 42, 0.5)"
    >
      <div style={styles.grid}>
        {faqItems.map((faq, i) => (
          <FaqItem key={i} question={faq.question} answer={faq.answer} />
        ))}
      </div>
    </SectionWrapper>
  );
};
